import { useFetchPurchaseAgreements } from '@retail/purchase-agreements/data-access';
import { PurchaseAgreement } from '@retail/purchase-agreements/types';
import { QueryOptions } from '@shared/fetch-utils';

interface Props extends QueryOptions {
  supplierNumber: number;
}

export const useAgreements = ({ supplierNumber, ...options }: Props) => {
  const { data: agreementDtos = [], isFetching: isFetchingAgreements } = useFetchPurchaseAgreements(
    {
      supplierId: supplierNumber,
      suspense: false,
      ...options,
    }
  );
  const agreements = agreementDtos.map(PurchaseAgreement.fromDto);

  return {
    agreements,
    nrOfAgreements: agreements.length,
    isFetchingAgreements,
  };
};
